import { IBatteryStatus } from '@/shared/interfaces';
export const TEST_BATTERY_DATA: IBatteryStatus = {
    batteryConnected: true,
    acPowerConnected: true,
    level: 100,
};
